export enum IncidentActionReason {
  RESOLVED = "RESOLVED",
  NOTREQUIRED = "NOTREQUIRED",
  SUPERSEDED = "SUPERSEDED",
}
